import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from '@/context/AuthContext';
import { AdminLayout } from '@/components/layout/AdminLayout';
import { Login } from '@/pages/Login';
import { Dashboard } from '@/pages/Dashboard';
import { Cameras } from '@/pages/Cameras';
import { Radio } from '@/pages/Radio';
import { Sessions } from '@/pages/Sessions';
import { Analytics } from '@/pages/Analytics';
import { UsersPage } from '@/pages/Users';
import { Integrations } from '@/pages/Integrations';
import { Assets } from '@/pages/Assets';
import { Settings } from '@/pages/Settings';
import { AuditLog } from '@/pages/AuditLog';
import { Ads } from '@/pages/Ads';
import { Security } from '@/pages/Security';
import { ApiDocs } from '@/pages/ApiDocs';
import { ApiKeys } from '@/pages/ApiKeys';
import { AccessDenied } from '@/pages/AccessDenied';
import '@/App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/access-denied" element={<AccessDenied />} />
          
          {/* Protected Admin Routes */}
          <Route element={<AdminLayout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/cameras" element={<Cameras />} />
            <Route path="/radio" element={<Radio />} />
            <Route path="/sessions" element={<Sessions />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/ads" element={<Ads />} />
            <Route path="/users" element={<UsersPage />} />
            <Route path="/integrations" element={<Integrations />} />
            <Route path="/assets" element={<Assets />} />
            <Route path="/security" element={<Security />} />
            <Route path="/api-docs" element={<ApiDocs />} />
            <Route path="/api-keys" element={<ApiKeys />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/audit-log" element={<AuditLog />} />
          </Route>

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      
      {/* Toast Notifications */}
      <Toaster 
        position="top-right"
        toastOptions={{
          style: {
            background: 'hsl(222.2 47% 8%)',
            border: '1px solid hsl(217.2 32% 17.5%)',
            color: 'hsl(210 40% 98%)',
          },
        }}
      />
    </AuthProvider>
  );
}

export default App;
